/* 🤖 this file was generated by svg-to-ts */
export const mgcIconDirections2Filled: {
  name: 'directions-2-filled';
  data: string;
} = {
  name: 'directions-2-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4.58 4.047c-.733.14-1.4.821-1.537 1.57-.06.33-.06 7.436 0 7.766.141.768.806 1.433 1.574 1.574.155.028 1.135.043 2.81.043H10v2.573c0 2.904-.008 2.821.299 3.128a.984.984 0 0 0 1.402 0c.307-.307.299-.224.299-3.128V15l2.33-.001c2.513 0 2.612-.007 3.023-.216.473-.239.528-.307 1.892-2.351.708-1.06 1.329-2.019 1.38-2.132.214-.467.214-1.132-.001-1.602-.051-.111-.671-1.07-1.379-2.13-1.364-2.044-1.419-2.112-1.892-2.351-.441-.224-.19-.216-6.633-.212-3.574.002-6.019.019-6.14.042"/></svg>`
};
